import React, { useState } from 'react';
import Col from 'react-bootstrap/Col';
import { Card } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import styles from "./GameShow.module.css"
import icon1 from "../../assets/icons/SVG/age.svg";
import icon2 from "../../assets/icons/SVG/tedad.svg";
import icon3 from "../../assets/icons/SVG/hardness.svg";
import icon4 from "../../assets/icons/SVG/location.svg";
import Gallery from "../gallery/Gallery";

const MyModal = (props) => {
  const { title, text, video, images, modalIconText1, modalIconText2, modalIconText3, modalIconText4 } = props;
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton/>
      <Modal.Body className="show-grid">
        <Container>
          <Row>
            <Col xs={12} md={4}>
              <h1 className={styles.modalTitle}>{title}</h1>
              <p className={styles.modalText}>{text}</p>
              <div className={styles.modalIconContainer}>
                <div className={styles.modalIcon}>
                  <img src={icon1} alt="icon1" />
                  <p className={styles.modalIconText}>{modalIconText1}</p>
                </div>
                <div className={styles.modalIcon}>
                  <img src={icon2} alt="icon2" />
                  <p className={styles.modalIconText}>{modalIconText2}</p>
                </div>
                <div className={styles.modalIcon}>
                  <img src={icon3} alt="icon3" />
                  <p className={styles.modalIconText}>{modalIconText3}</p>
                </div>
                <div className={styles.modalIcon}>
                  <img src={icon4} alt="icon4" />
                  <p className={styles.modalIconText}>{modalIconText4}</p>
                </div>
              </div>

            </Col>
            <Col md={6} lg={8} >
              <Gallery video={video} images={images} />
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
};

const GmaeShow = (props) => {
  const {
    imgsrc,
    title,
    text,
    showModal,
    onHideModal,
    video,
    images, // <-- add images prop here
    modalIconText1,
    modalIconText2,
    modalIconText3,
    modalIconText4
  } = props;
  const [modalShow, setModalShow] = useState(false);
  return (
    <div className={styles.cardCaontainer}>
      <div>
        <Card className={styles.card} onClick={() => setModalShow(true)}>
          <Card.Img src={imgsrc} alt="card-img" className={styles.cardImg} />
          <Card.Body>
            <Card.Title className={styles.cardTitle}>{title}</Card.Title>
          </Card.Body>
        </Card>
      </div>
      <MyModal
        show={showModal || modalShow}
        onHide={() => {
          setModalShow(false);
          onHideModal();
        }}
        title={title}
        text={text}
        video={video}
        images={images} // <-- pass images prop to MyModal
        modalIconText1={modalIconText1}
        modalIconText2={modalIconText2}
        modalIconText3={modalIconText3}
        modalIconText4={modalIconText4}
      />
    </div>
  );
};

export default GmaeShow;

